export const DEFAULT_TIMEOUT = 10000;

export const SEVERITY_ERROR = 'error';
export const SEVERITY_SUCCESS = 'success';
export const SEVERITY_WARNING = 'warning';
